
//NOTE: "Maintenance" and "Inspecting" are used at runtime, but not in the formal
//      type for the Listing model.
//      The listing model uses a declarations file, so we can't give it the enum
//      with its runtime benefits, like these switch cases. Worse, ApiListing
//      is stacked with other types types in a hierarchy, so we can't just move
//      it to a .ts file without a major refactor.
//
//TODO: Determine whether the enum should include these two. Remember that
//      it's also used for available filters.

import { ListingStatus } from "../models/constants";

/** Full chip utility classes; use "" to keep the host component’s base (primary) layer. */
export const listingStatusColor = (status: string) => {
  const n = status.trim().toLowerCase();
  switch (n) {
    case ListingStatus.Clean.toLowerCase():
      return "";
    case ListingStatus.Vacant.toLowerCase():
    case ListingStatus.Occupied.toLowerCase():
      return "text-white ring-1 ring-inset ring-secondary-main bg-secondary-main";
    case ListingStatus.Dirty.toLowerCase():
    case "maintenance":
      return "text-white ring-1 ring-inset ring-error-light bg-error-main";
    case ListingStatus.Cleaning.toLowerCase():
    case "inspecting":
      return "text-white ring-1 ring-inset ring-warning-light bg-warning-main";
    default:
      return "";
  }
};
